"use client";

import { cn } from "utils";
import { EdMarkIcon } from "@/src/components/Tracker/EdMarkIcon";

interface PortfolioInsightMeetEdHeaderProps {
  title: string;
  className?: string;
}

/** Figma Meet Ed row — 32px brand circle + Lexend title */
export const PortfolioInsightMeetEdHeader: React.FC<
  PortfolioInsightMeetEdHeaderProps
> = ({ title, className }) => {
  return (
    <div
      className={cn("flex items-center gap-3", className)}
      data-testid="portfolio-insight-header-view"
    >
      <div
        className="flex size-8 shrink-0 items-center justify-center rounded-full bg-background_brand_overlay20"
        data-testid="portfolio-insight-ed-chip"
        aria-hidden
      >
        <EdMarkIcon size={20} data-testid="portfolio-insight-ed-icon" />
      </div>
      <p className="headline_regular_s text-content_primary">{title}</p>
    </div>
  );
};
